import { SelectHTMLAttributes, ReactNode } from "react";
import styles from "./Select.module.css";
import { IconSelectCaret } from "./icons";

interface SelectProps
  extends Omit<SelectHTMLAttributes<HTMLSelectElement>, "className"> {
  label: string;
  helpText?: ReactNode;
}

export function Select({
  label,
  "aria-label": ariaLabel = label,
  helpText,
  ...props
}: SelectProps): ReactNode {
  return (
    <div className={styles.root}>
      {label && <div className={styles.label}>{label}</div>}
      <div className={styles.select}>
        <select
          aria-label={ariaLabel}
          className="active-darken focus-simple"
          {...props}
        />
        <IconSelectCaret size={24} className={styles.icon} />
      </div>
      {helpText && <p className={styles.help}>{helpText}</p>}
    </div>
  );
}
